import { Link } from "react-router-dom";

import { useCart } from "../../../../hooks";
import { STORE_INFO } from "../../../../utils";

import styles from "./StoreCartPage.module.scss";
import { buildWhatsAppMessage, buildWhatsAppUrl } from "./StoreCartPage.form";

export function StoreCartPage() {
  const { items, itemCount, updateQuantity, removeItem } = useCart();

  const hasWhatsAppNumber = Boolean(STORE_INFO.WHATSAPP_NUMBER);

  function handleCheckout() {
    if (!hasWhatsAppNumber) {
      return;
    }

    const message = buildWhatsAppMessage(items);
    const url = buildWhatsAppUrl(STORE_INFO.WHATSAPP_NUMBER, message);

    window.open(url, "_blank", "noopener,noreferrer");
  }

  if (items.length === 0) {
    return (
      <div className={styles.EmptyState}>
        <p>Tu carrito está vacío.</p>

        <Link to="/catalogo" className={styles.ContinueButton}>
          Ver catálogo
        </Link>
      </div>
    );
  }

  return (
    <div className={styles.StoreCartPage}>
      <header className={styles.PageHeader}>
        <h1>Carrito</h1>

        <p className={styles.ItemCount}>
          {itemCount} {itemCount === 1 ? "artículo" : "artículos"}
        </p>
      </header>

      <div className={styles.Layout}>
        <ul className={styles.ItemList}>
          {items.map((item) => (
            <li key={`${item.productId}-${item.variantId}`} className={styles.Item}>
              <Link
                to={`/producto/${item.slug}`}
                state={{ from: "/carrito" }}
                className={styles.ItemImageWrapper}
              >
                {item.image ? (
                  <img src={item.image} alt={item.name} className={styles.ItemImage} />
                ) : (
                  <span className={styles.ItemImagePlaceholder}>▣</span>
                )}
              </Link>

              <div className={styles.ItemInfo}>
                <Link
                  to={`/producto/${item.slug}`}
                  state={{ from: "/carrito" }}
                  className={styles.ItemName}
                >
                  {item.name}
                </Link>

                {item.attributesLabel && (
                  <span className={styles.ItemAttributes}>
                    {item.attributesLabel}
                  </span>
                )}
              </div>

              <div className={styles.ItemQuantity}>
                <button
                  type="button"
                  onClick={() =>
                    updateQuantity(item.productId, item.variantId, item.quantity - 1)
                  }
                  disabled={item.quantity <= 1}
                >
                  −
                </button>

                <span>{item.quantity}</span>

                <button
                  type="button"
                  onClick={() =>
                    updateQuantity(item.productId, item.variantId, item.quantity + 1)
                  }
                  disabled={item.quantity >= item.stock}
                >
                  +
                </button>
              </div>

              <button
                type="button"
                className={styles.RemoveButton}
                onClick={() => removeItem(item.productId, item.variantId)}
                aria-label={`Quitar ${item.name}`}
              >
                ✕
              </button>
            </li>
          ))}
        </ul>

        <aside className={styles.Summary}>
          <h2>Resumen</h2>

          <p className={styles.SummaryNote}>
            El precio, envío y cualquier costo adicional se confirman por
            WhatsApp al enviar tu pedido.
          </p>

          <button
            type="button"
            className={styles.CheckoutButton}
            onClick={handleCheckout}
            disabled={!hasWhatsAppNumber}
          >
            Finalizar pedido por WhatsApp
          </button>

          {!hasWhatsAppNumber && (
            <p className={styles.CheckoutDisabledNote}>
              Este canal todavía no está configurado.
            </p>
          )}
        </aside>
      </div>
    </div>
  );
}
